export default "__VITE_ASSET__C$UzYsmL__"